import { SmsStatus } from "@remi/enums/sms-status";

import { hasCapability, type User } from "../base";
import { REMI_AUTOMATIONS_USER_ID } from "../constant-users";

export const smsMessage = {
  delete: (
    user: User,
    smsMessage: {
      status: SmsStatus;
    },
  ) => {
    return smsMessage.status === SmsStatus.SCHEDULED && hasCapability(user, "smsMessage.delete");
  },
  reschedule: (
    user: User,
    smsMessage: {
      status: SmsStatus;
      authorPersonId: string;
    },
  ) => {
    const authoredByCaller = smsMessage.authorPersonId === user.person.id;
    const authoredByAutomations = smsMessage.authorPersonId === REMI_AUTOMATIONS_USER_ID;
    return (
      smsMessage.status === SmsStatus.CANCELED &&
      (authoredByCaller || authoredByAutomations) &&
      hasCapability(user, "smsMessage.delete")
    );
  },
  sendToHomeowner: (user: User) => hasCapability(user, "conversation.sms.homeowner.send"),
  sendToContractor: (user: User) => hasCapability(user, "conversation.sms.contractor.send"),
  send: (user: User) =>
    hasCapability(user, "conversation.sms.homeowner.send") || hasCapability(user, "conversation.sms.contractor.send"),
};
